var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.333 7.334a.667.667 0 0 0 0 1.333V7.334zm9.333.667.472.471a.667.667 0 0 0 0-.943l-.472.472zM8.471 2.863a.667.667 0 1 0-.943.942l.943-.942zm-.943 9.333a.667.667 0 1 0 .943.943l-.943-.943zM3.333 8.667h9.333V7.334H3.333v1.333zm4.195-4.862 4.667 4.667.943-.943L8.47 2.863l-.943.942zm4.667 3.724-4.667 4.667.943.943 4.667-4.667-.943-.943z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.e735e36df796a725e68b97ac29de07c9.svg";
export { ForwardRef as ReactComponent };